import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { fetchConsultantSummary } from "../services/dashboardService";

const BusinessIncentiveChart: React.FC<{
  month: number | "";
  year: number | "";
}> = ({ month, year }) => {
  const [chartData, setChartData] = useState<
    { consultant: string; amount: number }[]
  >([]);

  useEffect(() => {
    const loadChartData = async () => {
      try {
        if (typeof month === "number" && typeof year === "number") {
          const response = await fetchConsultantSummary(month, year);
          const rawData = response.data;

          const transformed = rawData.map((item: any) => ({
            consultant: item.consultant ?? "Unknown",
            amount: item.amount ?? 0,
          }));
          console.log("parthi2004" + JSON.stringify(transformed));
          setChartData(transformed);
        }
      } catch (error) {
        console.error("Failed to load ConsultantSummary:", error);
      }
    };
    loadChartData();
  }, [month, year]);

  return (
    <div className="p-4 border-2 border-blue-400 rounded-lg shadow-sm">
      <Typography variant="subtitle1" mb={3} fontWeight={500}>
        Business Report
      </Typography>

      <ResponsiveContainer width="100%" height={270}>
        <BarChart
          data={chartData}
          barSize={40}
          margin={{ top: 10, right: 20, left: 0, bottom: 20 }}
        >
          <CartesianGrid strokeDasharray="4 4" vertical={false} />
          <XAxis dataKey="consultant" tick={{ fontSize: 12 }} />
          <YAxis
            tickFormatter={(value) => value.toLocaleString("en-IN")}
            tick={{ fontSize: 12 }}
            width={50}
          />
          <Tooltip
            formatter={(value: number) => `₹${value.toLocaleString("en-IN")}`}
          />
          <Bar
            dataKey="amount"
            radius={[10, 10, 0, 0]}
            fill="url(#gradient)"
          />
          <defs>
            <linearGradient id="gradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#4f46e5" stopOpacity={1} />
              <stop offset="100%" stopColor="#818cf8" stopOpacity={0.6} />
            </linearGradient>
          </defs>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BusinessIncentiveChart;
